import React from "react";
import { useEffect, useState } from "react";
import {
  getAllCategory,
  getAllPrice,
  getAllZones,
} from "../../../services/kojaServices";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Swal from "sweetalert2";
import { AddPrice, deletePrice, editPricing } from "../../../services/adminServices";
import toast from "react-hot-toast";

const Pricing = () => {
  const [list, setList] = useState([]);
  const [zones, setZones] = useState([]);
  const [category, setcategory] = useState([]);
  const [item,setItem] = useState({})
  const [edit,setEdit] = useState(false)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getAllPrice();
        console.log(data);
        setList(data.result);
        const { data: zones } = await getAllZones();
        setZones(zones.result);
        const { data: category } = await getAllCategory();
        setcategory(category.result);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const addNew = async (values) => {
    try {
      console.log(values)
        const { data } = await AddPrice(values);
        toast.success("مورد جدید اضافه شد");
        console.log(data);
    } catch (err) {
      console.log(err);
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };
  const confirmDelete = (id) => {
    Swal.fire({
      title: "حذف آیتم",
      text: "ایا مطمئن هستید میخواهید این آیتم را حذف کنید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله",
      cancelButtonText:"انصراف"
    }).then((result) => {
      if (result.isConfirmed) {
        removeItem(id);
      }
    });
  };

  const removeItem = async (id) => {
    const allItem = [...list];
    console.log(id);
    try {
      setList(list.filter((item) => item.id !== id));
      const { data, status } = await deletePrice(id);
      console.log(data, status);
      if (status != 200) {
        setList(allItem);
      } else {
        Swal.fire("حذف شد", "آیتم با موفقیت حذف شد", "success");
      }
    } catch (err) {
      console.log(err);
      // setProducts(allProduct);
      const x = err.response.status;
      toast.error("خطایی رخ داده است مجدد تلاش کنید");
    }
  };

  const confirmEdit = (values) => {
    Swal.fire({
      title: "ویرایش آیتم",
      text: "ایا مطمئن هستید میخواهید این آیتم را ویرایش کنید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله",
      cancelButtonText:"انصراف"
    }).then((result) => {
      if (result.isConfirmed) {
        editItem(values);
      }
    });
  };

  const editItem = async (values) => {
    values.id = item.id
    console.log(values)

    try {
      const { data, status } = await editPricing(values);
      console.log(data, status);
      if (status != 200) {
      } else {
        Swal.fire("ویرایش شد", "آیتم با موفقیت ویرایش شد", "success");
      }
    } catch (err) {
      console.log(err);
      // setProducts(allProduct);
      const x = err.response.status;
      toast.error("خطایی رخ داده است مجدد تلاش کنید");
    }
  };
  return (
    <div>
      <Formik
        initialValues={{
          ExCategoryId:  item.ExCategoryId || "",
          ExZoneId: item.ExZoneId || "",
          userPrice: item.userPrice || "",
          expertPrice: item.expertPrice|| "",
          refreshUserPrice: item.refreshUserPrice || "",
          refreshExpertPrice: item.refreshExpertPrice || "",
          showPrice: item.showPrice || "",
        }}
        validationSchema={""}
        onSubmit={(values, { resetForm }) => {if(edit){
          confirmEdit(values)
        }else{
          addNew(values)
        }}}
        enableReinitialize={true}
      >
        {({ isSubmitting, errors, setFieldValue, handleChange, touched }) => (
          <Form>
            <div className="row  align-items-center justify-content-between text-end">
              <div className="mb-3 col-6 col-md-4 col-lg-3">
                <label>منطقه</label>
                <Field
                  name="ExZoneId"
                  className="w-100 admin-setting-input px-2 "
                  as="select"
                >
                <option>یک گزینه انتخاب کنید</option>
                  {zones.map((i, index) => (
                    <option value={i.id} key={index}>
                      {i.name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="ExZoneId"
                  render={(msg) => <div className="text-danger">{msg}</div>}
                />
              </div>
              <div className="mb-3 col-6 col-md-4 col-lg-3">
                <label>نوع ملک</label>
                <Field
                  name="ExCategoryId"
                  className="w-100 admin-setting-input px-2 "
                  as="select"
                >
                <option>یک گزینه انتخاب کنید</option>
                  {category.map((i, index) => (
                    <option value={i.id} key={index}>
                      {i.name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                  name="ExCategoryId"
                  render={(msg) => <div className="text-danger">{msg}</div>}
                />
              </div>
              <div className="mb-3 col-6 col-md-4 col-lg-3">
                <label>دریافتی از کاربر</label>
                <Field
                  name="userPrice"
                  type="number"
                  className="w-100 admin-setting-input px-2 "
                />
                <ErrorMessage
                  name="userPrice"
                  render={(msg) => <div className="text-danger">{msg}</div>}
                />
              </div>
              <div className="mb-3 col-6 col-md-4 col-lg-3">
                <label>پرداختی به کارشناس</label>
                <Field
                  name="expertPrice"
                  type="number"
                  className="w-100 admin-setting-input px-2 "
                />
                <ErrorMessage
                  name="expertPrice"
                  render={(msg) => <div className="text-danger">{msg}</div>}
                />
              </div>
              <div className="mb-3 col-6 col-md-4 col-lg-3">
                <label>قیمت بروزرسانی کاربر</label>
                <Field
                  name="refreshUserPrice"
                  type='number'
                  className="w-100 admin-setting-input px-2 "
                />
                <ErrorMessage
                  name="refreshUserPrice"
                  render={(msg) => <div className="text-danger">{msg}</div>}
                />
              </div>
              <div className="mb-3 col-6 col-md-4 col-lg-3">
                <label>قیمت بروزرسانی کارشناس</label>
                <Field
                  name="refreshExpertPrice"
                  type='number'
                  className="w-100 admin-setting-input px-2 "
                />
                <ErrorMessage
                  name="refreshExpertPrice"
                  render={(msg) => <div className="text-danger">{msg}</div>}
                />
              </div>
            <div className="text-end col-6 col-md-4 col-lg-3">
            <button
              className="btn ms-3"
              style={{
                width: "100px",
                backgroundColor: "#EF971C",
                borderRadius: "20px",
              }}
            >
              {edit ? "ویرایش ": "افزودن"}
            </button>
          </div>
            </div>
          </Form>
        )}
      </Formik>
      <div className="table-responsive p-3 mt-4 admin-setting-tabel-box">
        <table
          className="table table-bordered text-center mb-0"
          style={{ borderRadius: "20px", borderColor: "#fff" }}
        >
          <thead>
            <tr style={{ color: "#000" }}>
              <th scope="col">ردیف</th>
              <th scope="col">نوع ملک</th>
              <th scope="col">منطقه</th>
              <th scope="col">مبلغ دریافتی از کاربر</th>
              <th scope="col">مبلغ پرداختی به کارشناس</th>
              <th scope="col">قیمت دریافتی از کاربر بابت بروزرسانی</th>
              <th scope="col">مبلغ پرداختی به کارشناسی بابت بروزرسانی</th>
              <th scope="col">مبلغ بیعانه</th>
            </tr>
          </thead>
          <tbody>
            {list.map((i, index) => (
              <tr style={{ color: "#000" }} key={index}>
                <td>{index + 1}</td>
                <td>{i.Ex_Category.name}</td>
                <td>{i.Ex_Zone.name}</td>
                <td>{i.userPrice.toLocaleString()}</td>
                <td>{i.expertPrice.toLocaleString()}</td>
                <td>{i.refreshUserPrice.toLocaleString()}</td>
                <td>{i.refreshExpertPrice.toLocaleString()}</td>
                <td>
                  <button
                    className="btn ms-3"
                    style={{
                      width: "80px",
                      backgroundColor: "#EF971C",
                      borderRadius: "20px",
                    }}
                    onClick={() => {
                      confirmDelete(i.id);
                    }}
                  >
                    حذف
                  </button>
                  <button
                    className="btn ms-3"
                    style={{
                      width: "80px",
                      backgroundColor: "#EF971C",
                      borderRadius: "20px",
                      marginTop:"5px"
                    }}
                    onClick={() => {
                      setItem(i)
                      setEdit(true)
                    }}
                  >
                    ویرایش
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Pricing;
